import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import Moment from "moment";

import { ApiService } from "src/app/api.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";

@Component({
	selector: "app-fleetwide-firmware",
	templateUrl: "./fleetwide-firmware.component.html",
	styleUrls: ["./fleetwide-firmware.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class FleetwideFirmwareComponent {
	api = inject(ApiService);


	public ignoreMyOrg = true;

	async DownloadFirmware() {
		await this.api.ExportFirmware("Foresight FW " + Moment().format("YYYY-MM-DD HHmmss") + ".csv", this.ignoreMyOrg ? this.api.user.organization_id : undefined);
	}
}
